import {UseSocketOptions} from 'socket.io-react-hook/lib/cjs/types';

import {SocketNamespace} from 'enums';

import {useNamespaceSocket} from './namespace-socket';

export const useGroupSessionSocket = <T>(jwt: string, options: UseSocketOptions<T>) =>
    useNamespaceSocket(SocketNamespace.GroupSession, {
        ...options,
        enabled: !!jwt && options.enabled,
        auth: {
            token: jwt
        }
    });